import React from "react";

interface LabelProps {
  /** Lets a custom control (e.g. Dropdown) name itself with aria-labelledby. */
  id?: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
}

const Label: React.FC<LabelProps> = ({
  id,
  htmlFor,
  children,
  className = "",
  required = false,
  disabled = false,
  error = false,
  success = false,
}) => {
  let labelClasses = `block mb-1.5 text-sm font-medium ${className} `;

  if (disabled) {
    labelClasses += "text-gray-400 cursor-not-allowed";
  } else if (error) {
    labelClasses += "text-error-500";
  } else if (success) {
    labelClasses += "text-success-500";
  } else {
    labelClasses += "text-gray-700 dark:text-gray-300";
  }

  return (
    <label id={id} htmlFor={htmlFor} className={labelClasses}>
      {children}
      {required && <span className="ml-1 text-error-500">*</span>}
    </label>
  );
};

export default Label;
